import Vue from 'vue'
import Vuex from 'vuex'

// Modules
// import axios from 'axios';
// import useJwt from '@/auth/jwt/useJwt';
import LogsService from '@/services/LogsService';
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import AuthModule from './modules/AuthModule';
import MyCallsModule from './modules/MyCallsModule';
import RequestCallModule from './modules/RequestCallModule';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isElectron: false,
    fullscreen: false,
  },
  mutations: {
    SET_IS_ELECTRON(state, value) {
      state.isElectron = value;
    },
    SET_IS_FULLSCREEN(state, value) {
      state.fullscreen = value;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    sendStat({ commit }, stat) {
      LogsService.sendLog(stat.meta, stat.description);
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth: AuthModule,
    myCalls: MyCallsModule,
    requestCall: RequestCallModule,
  },
  strict: process.env.DEV,
})
